import { useContext } from 'react';
import { BulkDownloadDocumentsJobContext } from './context';

export default function useBulkDownloadDocumentsJobContext() {
  return useContext(BulkDownloadDocumentsJobContext);
}
